import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormControlService } from './../../shared/services/form-control.service';
import { Textarea } from './../../models/editors/textarea.model';
import { ApiService } from './../../shared/services/api.service';
import { AlertService } from './../../shared/services/alert.service';
import { InlineFormBase } from './../../shared/components/base/inline-form/inline-form.base.component';
import { Textbox } from './../../models/editors/textbox.model';

export const SUCCESS_MESSAGE = 'Nastavení bylo úspěšně uloženo!';
export const ERROR_MESSAGE = 'Při ukládání bohužel nastala chyba. Zkuste to prosím později.';

@Component({
  selector: 'swb-scripts',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class ScriptsComponent extends InlineFormBase<any> {

  public headerTitle = 'Vlastní skripty (např. Google Analytics)';

  public get fieldsConfig(): Array<any> {
    return [
      new Textarea({
        key: 'content_technical',
        label: 'Technické skripty',
        validators: [],
        isMultilang: false
      }),
      new Textarea({
        key: 'content_stats',
        label: 'Statistické skripty',
        validators: [],
        isMultilang: false
      }),
      new Textarea({
        key: 'content_preferences',
        label: 'Preferenční skripty',
        validators: [],
        isMultilang: false
      }),
      new Textbox({
        key: 'title_bar',
        label: 'Titulek cookie lišty',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textarea({
        key: 'content_bar',
        label: 'Text v cookie liště',
        validators: [Validators.required],
        wysiwyg: 'cookie-bar',
        isMultilang: true
      }),
      new Textarea({
        key: 'content_marketing',
        label: 'Marketingové skripty',
        validators: [],
        isMultilang: false
      }),
      new Textbox({
        key: 'title_general',
        label: 'Titulek pop-upu s nastavením cookies',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textarea({
        key: 'content_general',
        label: 'Text pop-upu s nastavením cookies',
        validators: [Validators.required],
        wysiwyg: 'cookie-content',
        isMultilang: true
      }),
      new Textbox({
        key: 'title_technical',
        label: 'Popis pro technické skripty',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textbox({
        key: 'title_stats',
        label: 'Popis pro statistické skripty',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textbox({
        key: 'title_preferences',
        label: 'Popis pro preferenční skripty',
        validators: [Validators.required],
        isMultilang: true
      }),
      new Textbox({
        key: 'title_marketing',
        label: 'Popis pro marketingové skripty',
        validators: [Validators.required],
        isMultilang: true
      })
    ];
  }

  public url = 'scripts';

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }
}
